import React, { useContext, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { Home } from "./pages/Home";
import { Login } from "./pages/Login";
import { Offers } from "./pages/Offers";
import { Cupom } from "./pages/Cupom";
import { Register } from "./pages/Register";
import { ResetPassword } from "./pages/ResetPassword";
import Carteira from "./pages/Carteira";
import AdminSaques from "./pages/AdminSaques";
import Pagamento from "./pages/Pagamento";
import logo from "./assets/logo.png";
import PainelOfertas from "./pages/PainelOfertas";
import AdminCsvUpload from "./pages/AdminCsvUpload";
import PainelHome from "./pages/PainelHome";
import PainelUsuarios from "./pages/PainelUsuarios";
import Cookies from "js-cookie";

import { ProtectedRoute } from "./routes/ProtectedRoute";
import { AdminRoute } from "./routes/AdminRoute";

function App() {
  const { logout } = useContext(AuthContext);

  // 🔄 Trata parâmetros da URL e cookies
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const hasParams = Array.from(urlParams.entries()).length > 0;

    if (!hasParams) return;

    const novaEntrada = {
      params: {},
      referer: document.referrer || null,
      recebidoEm: new Date().toISOString(),
    };

    for (const [key, value] of urlParams.entries()) {
      novaEntrada.params[key] = value;
    }

    const cookieRaw = Cookies.get("entradaCompleta");
    let deveAtualizar = false;

    if (!cookieRaw) {
      deveAtualizar = true;
    } else {
      try {
        const cookieAntigo = JSON.parse(cookieRaw);
        const antigos = JSON.stringify(cookieAntigo.params || {});
        const novos = JSON.stringify(novaEntrada.params);

        if (antigos !== novos) {
          deveAtualizar = true;
        }
      } catch (err) {
        console.warn("⚠️ Cookie entradaCompleta malformado. Será refeito.");
        deveAtualizar = true;
      }
    }

    if (deveAtualizar) {
      const isLocalhost = window.location.hostname === "localhost";

      Cookies.set("entradaCompleta", JSON.stringify(novaEntrada), {
        expires: 7,
        sameSite: isLocalhost ? "Lax" : "None",
        secure: !isLocalhost,
      });
    }

    const source = urlParams.get("source");
    const sourceAfiliado = urlParams.get("sub_aff_id");
    const tid = urlParams.get("tid") || urlParams.get("aff_click_id");
    
    if (source) {
      localStorage.setItem("source", source);
}

    if (sourceAfiliado) {
  const sourceAfiliadoLimpo = sourceAfiliado.split('_')[0];
  localStorage.setItem("sourceAfiliado", sourceAfiliadoLimpo);
  localStorage.setItem("aff_sub7", sourceAfiliadoLimpo);
}


    if (tid) {
      localStorage.setItem("tid", tid); // ✅ salva no localStorage
}

  }, []);

  // ⏱️ Logout automático após 10 minutos de inatividade
  useEffect(() => {
    let timeout;

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        logout();
      }, 10 * 60 * 1000); // 10 minutos
    };

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      clearTimeout(timeout);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [logout]);

  // ❌ Logout ao fechar ou recarregar a aba
  useEffect(() => {
    const handleBeforeUnload = () => {
      logout();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [logout]);

  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen flex flex-col bg-gray-100">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/offers" element={<ProtectedRoute><Offers /></ProtectedRoute>} />
              <Route path="/cupom/:id" element={<ProtectedRoute><Cupom /></ProtectedRoute>} />
              <Route path="/carteira" element={<ProtectedRoute><Carteira /></ProtectedRoute>} />
              <Route path="/pagamento" element={<ProtectedRoute><Pagamento /></ProtectedRoute>} />
              <Route path="/admin/saques" element={<AdminRoute><AdminSaques /></AdminRoute>} />
              <Route path="/admin/ofertas" element={<AdminRoute><PainelOfertas /></AdminRoute>} />
              <Route path="/admin/cashbacks" element={<AdminRoute><AdminCsvUpload /></AdminRoute>} />
              <Route path="/admin/home" element={<AdminRoute><PainelHome /></AdminRoute>} />
              <Route path="/admin/usuarios" element={<AdminRoute><PainelUsuarios /></AdminRoute>} />
            </Routes>
          </main>

          <footer className="bg-[#020C24] text-white text-center py-6 px-4 text-sm">
            <div className="max-w-5xl mx-auto flex flex-col items-center space-y-4">
              <img src={logo} alt="Cashbet Logo" className="w-32 h-auto" />
              <p className="leading-snug text-sm sm:text-base">
                Outlier Media Marketing Digital LTDA — CNPJ: 51.821.579/0001-94<br />
                Endereço: Av. Paulista, n.º 1636, Sala 1504<br />
                Bairro: Bela Vista, São Paulo, SP - CEP: 01310-200
              </p>
            </div>
          </footer>
        </div>
      </AuthProvider>
    </Router>
  );
}

function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const [userName, setUserName] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    if (user && user.email) {
      setUserName(user.email);
    } else {
      setUserName("");
    }
  }, [user]);

  return (
    <nav className="bg-gradient-to-r from-[#020C24] via-[#020C24] to-[#015FFF] text-white p-4 shadow relative">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img src={logo} alt="Cashbet Logo" className="w-32 h-auto" />
        </Link>

        <button className="md:hidden focus:outline-none" onClick={() => setMenuOpen(!menuOpen)}>
          <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
            <path
              d="M4 6h16M4 12h16M4 18h16"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>

        <ul className="hidden md:flex space-x-4 items-center">
          <li><Link to="/" className="hover:underline">Home</Link></li>
          <li><Link to="/offers" className="hover:underline">Ofertas</Link></li>

          {!user ? (
            <>
              <li><Link to="/register" className="hover:underline">Cadastrar</Link></li>
              <li><Link to="/login" className="hover:underline">Login</Link></li>
            </>
          ) : (
            <li className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                onBlur={() => setTimeout(() => setDropdownOpen(false), 150)}
                className="hover:underline focus:outline-none"
              >
                {userName || "Minha Conta"} ▼
              </button>

              {dropdownOpen && (
                <ul className="absolute right-0 mt-2 bg-white text-black rounded shadow-md w-48 z-50">
                  <li><Link to="/carteira" className="block px-4 py-2 hover:bg-gray-200">Minha Carteira</Link></li>
                  <li><Link to="/reset-password" className="block px-4 py-2 hover:bg-gray-200">Redefinir Senha</Link></li>
                  {user.role === "admin" && (
                    <>
                      <li><Link to="/admin/saques" className="block px-4 py-2 hover:bg-gray-200">Admin Saques</Link></li>
                      <li><Link to="/admin/ofertas" className="block px-4 py-2 hover:bg-gray-200">Painel de Ofertas</Link></li>
                      <li><Link to="/admin/cashbacks" className="block px-4 py-2 hover:bg-gray-200">Upload CSV</Link></li>
                      <li><Link to="/admin/home" className="block px-4 py-2 hover:bg-gray-200">Painel da Home</Link></li>
                      <li><Link to="/admin/usuarios" className="block px-4 py-2 hover:bg-gray-200">Painel de Usuários</Link></li>
                    </>
                  )}
                  <li>
                    <button onClick={logout} className="w-full text-left px-4 py-2 hover:bg-gray-200">Sair</button>
                  </li>
                </ul>
              )}
            </li>
          )}
        </ul>
      </div>

      {menuOpen && (
        <div className="md:hidden mt-4 space-y-2 text-center">
          <Link to="/" className="block py-2 hover:underline" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/offers" className="block py-2 hover:underline" onClick={() => setMenuOpen(false)}>Ofertas</Link>

          {!user ? (
            <>
              <Link to="/register" className="block py-2 hover:underline" onClick={() => setMenuOpen(false)}>Cadastrar</Link>
              <Link to="/login" className="block py-2 hover:underline" onClick={() => setMenuOpen(false)}>Login</Link>
            </>
          ) : (
            <>
              <Link to="/carteira" className="block py-2 hover:underline" onClick={() => setMenuOpen(false)}>Minha Carteira</Link>
              <Link to="/reset-password" className="block py-2 hover:underline" onClick={() => setMenuOpen(false)}>Redefinir Senha</Link>
              {user.role === "admin" && (
                <>
                  <Link to="/admin/saques" className="block py-2 hover:underline" onClick={() => setMenuOpen(false)}>Admin Saques</Link>
                  <Link to="/admin/ofertas" className="block py-2 hover:underline" onClick={() => setMenuOpen(false)}>Painel de Ofertas</Link>
                  <Link to="/admin/cashbacks" className="block py-2 hover:underline" onClick={() => setMenuOpen(false)}>Upload CSV</Link>
                  <Link to="/admin/home" className="block py-2 hover:underline" onClick={() => setMenuOpen(false)}>Painel da Home</Link>
                  <Link to="/admin/usuarios" className="block py-2 hover:underline" onClick={() => setMenuOpen(false)}>Painel de Usuários</Link>
                </>
              )}
              <button
                onClick={() => {
                  logout();
                  setMenuOpen(false);
                }}
                className="block py-2 w-full text-center hover:underline"
              >
                Sair
              </button>
            </>
          )}
        </div>
      )}
    </nav>
  );
}

export default App;
